import type { Router } from 'vue-router';
import { useConfigStore } from '@/stores/configStore';

export function beforeEach(router: Router) {
  router.beforeEach((to, _from, next) => {
    const configStore = useConfigStore();
    
    // Guard /summary : config complète requise
    if (to.name === 'Summary' && !configStore.isConfigValid) {
      next({ name: 'Configurator' });
      return;
    }
    
    // Sync état depuis query params
    if (to.query.config) {
      configStore.loadFromQuery(to.query.config as string);
    }
    
    next();
  });
}